import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModalHeader = props => {
  const {
    closeRequestAccessModal
  } = props;
  return /*#__PURE__*/_jsxs(DialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.modal.heading"
      })
    }), /*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "approval-modal-close",
      onClick: closeRequestAccessModal
    })]
  });
};
export default ApprovalRequestAccessModalHeader;